import React from 'react';

import { SelectedTrips } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardWrap';
import { TicketSelectionTab } from './TicketSelectionTab';

export interface TicketsTabProps {
	selectedTrips: SelectedTrips;
}

export function TicketsTab({ selectedTrips }: TicketsTabProps) {
	return <TicketSelectionTab selectedTrips={selectedTrips} />;
}
